import { skipToken } from '@tanstack/react-query';
import { useMemo } from 'react';
import { Record, RecordWithProtocol } from '../../types/sharedTypeImpl.ts';
import { trpc } from '../../utils/trpc/trpc.ts';


interface Props {
    record: Record,
}

export function useRecordsSelect({
    record,
}: Props) {

    if (record.measurementType === 'production' && !record.orderNumber) {
        throw new Error('orderNumber must be set if recordType is production');
    }

    const recordsFetch = trpc.records.getWithProtocols.useQuery(
        {
            orderNumber: record.orderNumber,
            protocolPartDisplayName: record.protocolPartDisplayName,
            isDraft: false,
        },
        {
            enabled: record.measurementType === 'production',
            refetchOnWindowFocus: false,
        }
    );

    const protocolFetch = trpc.protocols.getById.useQuery(
        record.measurementType === 'ioqc' ? record.protocolId : skipToken,
        { staleTime: Infinity }
    );

    const ioqcRecordsArray = useMemo(() => {
        if (record.measurementType !== 'ioqc') return undefined;
        if (!protocolFetch.data || protocolFetch.data._id !== record.protocolId) return undefined;
        const recordWithProtocol = { ...record, protocol: protocolFetch.data } as RecordWithProtocol;
        return [recordWithProtocol];
    }, [record, protocolFetch.data]);

    const records = record.measurementType === 'production' ? recordsFetch.data : ioqcRecordsArray;
    const isLoading = record.measurementType === 'production' ? recordsFetch.isLoading : protocolFetch.isLoading;

    return { records, isLoading };
}
